import useTranslation from 'next-translate/useTranslation';

// Hooks
import { useMessageFilter } from '@/utils/hooks/conversations/useMessageFilter';

// Libs
import { MESSAGE_FILTER_META } from '@/components/pages/conversations/SocialInbox/const';

// Components
import Badge from '@/components/base/Badge';
import {
    SocialInboxActions,
    SocialInboxFilters,
    SocialInboxTypeTitle
} from '@/components/pages/conversations/SocialInbox';

export function SocialInboxHeader() {
    const { messageFilter } = useMessageFilter();
    const { t } = useTranslation('conversations');

    return (
        <div className="flex flex-col gap-5 pr-4">
            <div className="hidden items-center gap-2 sm:flex">
                <SocialInboxTypeTitle classNameTextSize="text-16" messageFilter={messageFilter} />

                {messageFilter === MESSAGE_FILTER_META.dm.key && (
                    <Badge variant="info">{t('social_inbox.instagram_accounts_only')}</Badge>
                )}
            </div>

            <div className="flex justify-between">
                <SocialInboxFilters />

                <SocialInboxActions />
            </div>
        </div>
    );
}
